import { Provider } from '@angular/core';

import { PdfRepositoryImpl } from '@app/data/repositories/ptrab/pdf/pdf.repository';
import { PDF_REPOSITORY } from '@app/domain/repositories/ptrab/pdf/pdf.repository.contract';

export const pdfRepositoryProvider: Provider = {
  provide: PDF_REPOSITORY,
  useClass: PdfRepositoryImpl
};
